import App from "../App";

/**
 * Responsible for storing data locally.
 */
class LocalData {

    protected versionPrefix: string;

    constructor() {
        this.versionPrefix = "v2";
    }


    /**
     * Save a value under a specific identifier.
     * @public
     * @param name
     * @param value
     */
    saveValue(name: string, value: any) {
        try {
            localStorage.setItem(this.versionPrefix + App.config.gameId + name, value);
        } catch (e) {
            console.log("Cannot save to local storage.");
        }
    }


    /**
     * Retrieve a value under a specific identifier.
     * @public
     * @param name
     */
    getValue(name: string) {
        return localStorage.getItem(this.versionPrefix + App.config.gameId + name);
    }


    /**
     * Retrieve a value and cast it to a Number
     * @param name
     * @returns {number}
     */
    getNumber(name: string) {
        let val = this.getValue(name);
        let num;

        if (val !== null) {
            num = Number(val);
        }

        return num;
    }


    /**
     * Get a boolean value with specific identifier. If such identifier has not been previously used
     * it is saved with the specified init state.
     * @public
     * @param name
     * @param initState
     * @returns {Boolean}
     */
    getBooleanValue(name: string, initState = true): boolean {
        let b = this.getValue(name);

        if (b === null) {
            this.saveValue(name, initState);
        } else {
            return b === "true";
        }

        return !!b;
    }


}


export default new LocalData();
